import * as React from 'react';
import { Link } from 'react-router-dom';
import { Message } from '@verclam/ui-kit';

type Props = {
	readonly message: string;
};

/**
 * Renders the server's own wording verbatim, plus a single accompanying block valid for every
 * dead-link cause — expired, revoked, or already consumed: a `410` carries no discriminant of its
 * own to tell them apart, only the server's message does.
 */
const InvitationGone: React.FC<Props> = ({ message }) => {
	return (
		<React.Fragment>
			<Message severity="warn" text={message} />
			<p>Demandez une nouvelle invitation à votre administrateur.</p>
			<p>
				<Link to="/login">Se connecter</Link>
			</p>
		</React.Fragment>
	);
};

export default InvitationGone;
